import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './DeviceFeatures.css';

const DeviceFeatures = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-20% 0px -20% 0px' });
  return (
    <motion.section
      className="device-features-section"
      ref={ref}
      initial={{ opacity: 0 }}
      animate={isInView ? { opacity: 1 } : {}}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <h2 className="device-features-title">Device Features</h2>
      <div className="device-features-content">
        <div className="features-grid">
          <div className="feature-card">
            <img src="/images/Transcription1.png" alt="Smart Transcription" className="feature-icon" />
            <p className="feature-text">Smart Transcription</p>
          </div>
          <div className="feature-card">
            <img src="/images/ClinicalHealth.png" alt="Clinical Notes Generation" className="feature-icon" />
            <p className="feature-text">Clinical Notes Generation</p>
          </div>
          <div className="feature-card">
            <img src="/images/ArtificialInteligance.png" alt="Artificial Intelligence" className="feature-icon" />
            <p className="feature-text">Artificial Intelligence</p>
          </div>
          <div className="feature-card">
            <img src="/images/Languagetranslation.png" alt="Multilingual Support" className="feature-icon" />
            <p className="feature-text">Multilingual Support</p>
          </div>
          <div className="feature-card">
            <img src="/images/OfflineMode.png" alt="Offline-First Mode" className="feature-icon" />
            <p className="feature-text">Offline-First Mode</p>
          </div>
        </div>
        <div className="device-image-container">
          <img 
            src="/images/GenixPendent.png" 
            alt="Genix Pendant Device" 
            className="main-device-image"
          />
        </div>
      </div>
    </motion.section>
  );
};

export default DeviceFeatures; 